import { Snapshot } from '@ember-data/store';
import pick from 'lodash-es/pick';
import ApplicationSerializer from 'uplisting-frontend/serializers/application';

const CREATE_ATTRIBUTES = ['body', 'resource_type', 'resource_id'];
const UPDATE_ATTRIBUTES = ['body'];

export default class TeamMessageSerializer extends ApplicationSerializer {
  serialize(snapshot: Snapshot, options: object) {
    const data = super.serialize(snapshot, options);

    if (snapshot.id) {
      // @ts-expect-error - we have no typings for the json api
      data.data.attributes = pick(data.data.attributes, UPDATE_ATTRIBUTES);
      // @ts-expect-error - we have no typings for the json api
      delete data.data.relationships;
    } else {
      // @ts-expect-error - we have no typings for the json api
      data.data.attributes = pick(data.data.attributes, CREATE_ATTRIBUTES);

      const conversation = snapshot.belongsTo('teamConversation');

      // @ts-expect-error - we have no typings for the json api
      data.data.relationships = conversation
        ? { team_conversation: { data: { id: conversation.id } } }
        : {};
    }

    return data;
  }
}

declare module 'ember-data/types/registries/serializer' {
  interface SerializerRegistry {
    'team-message': TeamMessageSerializer;
  }
}
